import React, {useEffect, useRef, useState} from 'react';
import ImageWrapper from '../ImageWrapper/ImageWrapper';
import ProductTitle from '../ProductTitle/ProductTitle';
import PricesBox from '../PricesBox/PricesBox';
import QuantitySelector from '../QuantitySelector/QuantitySelector';
import trashIcon from './images/trash.png';
import trashIconActive from './images/trash-hover.png';
import './CartItem.css';

function CartItem({itemId, product, quantity, allowQuantityChange, onImageClick, onQuantityChange, onDelete}) {
    const [isPressingDelete, setIsPressingDelete] = useState(false);
    const deleteTimeoutRef = useRef(null);

    useEffect(() => {
        addDeleteReleaseListener();
        return () => {
            removeDeleteReleaseListener();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleImageClick = () => {
        if (onImageClick) onImageClick(product);
    };

    const handleQuantityChange = (newQuantity) => {
        if (allowQuantityChange && onQuantityChange && itemId) onQuantityChange(itemId, product.id, newQuantity);
    };

    const addDeleteReleaseListener = () => {
        document.addEventListener('mouseup', handleDeleteButtonRelease);
        document.addEventListener('touchend', handleDeleteButtonRelease);
    };

    const removeDeleteReleaseListener = () => {
        document.removeEventListener('mouseup', handleDeleteButtonRelease);
        document.removeEventListener('touchend', handleDeleteButtonRelease);
    };

    const handleDeleteButtonPress = (event) => {
        event.preventDefault();
        setIsPressingDelete(true);
    };

    const handleDeleteButtonRelease = () => {
        setIsPressingDelete(false);
    };

    useEffect(() => {
        if (isPressingDelete) startResizeTimeout();
        else stopResizeTimeout();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPressingDelete]);

    const startResizeTimeout = () => {
        deleteTimeoutRef.current = setTimeout(() => {
            handleDelete();
        }, 2200);
    };

    const stopResizeTimeout = () => {
        if (deleteTimeoutRef && deleteTimeoutRef.current) clearTimeout(deleteTimeoutRef.current);
    };

    const handleDelete = () => {
        if (onDelete && itemId) onDelete(itemId, product.id);
    };

    const deleteIconstyle = () => {
        return {
            background: isPressingDelete ? '#CD5C5C' : '#FFFFFF'
        };
    };

    const deleteEffectStyle = () => {
        return {
            width: isPressingDelete ? '100%' : 0,
            padding: isPressingDelete ? 15 : 0,
            color: isPressingDelete ? '#FFFFFF' : 'transparent',
            opacity: isPressingDelete ? 1 : 0
        };
    };

    const renderDeleteButton = () => {
        return (
            <>
                <div className='cart-item_delete-effect' style={deleteEffectStyle()}>Presione por 2 segundos para eliminar</div>
                <div className='cart-item_delete-wrapper'>
                    <div className='cart-item_delete' onMouseDown={handleDeleteButtonPress} onTouchStart={handleDeleteButtonPress} style={deleteIconstyle()}>
                        <ImageWrapper
                            image={isPressingDelete ? trashIconActive : trashIcon}
                            alt='Delete'
                            display='block'
                            width={25}
                            height='auto'
                            errorWidth={undefined}
                            errorHeight={undefined}
                            errorPadding={undefined}
                            margin={5}
                            borderRadius={0}
                            transition={true}
                            loadDelay={0.1}
                            onLoad={undefined}
                            onMouseEnter={undefined}
                            onMouseLeave={undefined}
                        />
                    </div>
                </div>
            </>
        );
    };

    return (
        <div className='cart-item'>
            <div className='cart-item_top-row'>
                <div className='cart-item_image-container' onClick={handleImageClick}>
                    <ImageWrapper
                        image={product.getMainImage('l')}
                        alt='Product'
                        display='block'
                        width={100}
                        height='auto'
                        errorWidth={undefined}
                        errorHeight={undefined}
                        errorPadding={undefined}
                        margin={5}
                        borderRadius={0}
                        transition={true}
                        loadDelay={0.1}
                        onLoad={undefined}
                        onMouseEnter={undefined}
                        onMouseLeave={undefined}
                    />
                </div>
                <div className='cart-item_product-info'>
                    <div className='cart-item_product-title'>
                        <ProductTitle product={product}/>
                    </div>
                    {product.hasAnyPrice() && (
                        <div className='cart-item_product-prices'>
                            <PricesBox product={product} mode='cartItem'/>
                        </div>
                    )}
                </div>
                {onDelete && renderDeleteButton()}
            </div>
            {(allowQuantityChange || !product.isValid()) && (
                <>
                    <div className='cart-item_bottom-row'>
                        {product.isValid() && (
                            <div className='cart-item_quantity-selector'>
                                <QuantitySelector quantity={quantity} minQuantity={1} maxQuantity={product.maxPerItem} onChange={handleQuantityChange}/>
                            </div>
                        )}
                        {(!product.isValid()) && (
                            <div className='cart-item_error'>Lo sentimos, este producto no está disponible y ha sido eliminado del carro</div>
                        )}
                    </div>
                    <div className={`cart-item_bottom-row-shadow${!product.isValid() ? ' error' : ''}`}>
                    </div>
                </>
            )}
        </div>
    );
}

export default CartItem;